import AssetService from '../../../../shared/services/AssetService';
import ChangeFile from '../../../../shared/components/ChangeFile';
import DefaultImage from '../../../images/default-image.jpg';
import Grid from '@mui/material/Unstable_Grid2';
import { IconTextComponent } from '../../../models/LessonComponent';
import ImageIcon from '@mui/icons-material/Image';
import { InlineQuillEdit } from '../../InlineQuillEdit';
import LessonComponentService from '../../../services/LessonComponentService';
import React from 'react';
import { cloneDeep } from 'lodash';
import styles from '../../../styles/IconText.module.css';
import { useLessonContext } from '../../../models/LessonContext';
import { useLessonEditContext } from '../../../models/LessonEditContext';
import useThemes from '../../../../shared/hooks/useThemes';

export interface IconTextEditorProps {
  component: IconTextComponent;
}

const positionMap = {
  start: 'left',
  center: 'center',
  end: 'right'
};

export const IconText = (props: IconTextEditorProps) => {
  const { mode } = useLessonContext();
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;
  const paragraphStyle = muiTheme.typography.custom1;

  const { content, settings } = props.component;
  const { position, shape, size } = settings?.iconSettings;
  const { handleSettingsChange } = useLessonEditContext();

  const sxProps = {
    '@media (max-width: 499px)': {
      width: '100% !important',
      textAlign: positionMap[position]
    }
  };

  const handleTextChange = (value: string) => {
    const copy = cloneDeep(props.component);
    copy.content.text = value;
    handleSettingsChange(copy);
  };

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      alignItems="center"
      style={{ fontFamily }}
    >
      <Grid
        container
        spacing={1}
        justifyContent="center"
        className={styles.gridContainer}
      >
        <Grid
          minWidth={'auto'}
          style={{
            alignSelf: position,
            backgroundColor: !settings.assetkey ? 'lightgrey' : ''
          }}
          className={styles.imgContainer}
          sx={sxProps}
        >
          {settings.assetkey ? (
            <img
              src={AssetService.getAssetUrl(settings.assetkey) || DefaultImage}
              className={`${styles.defaultImgStyle} ${
                shape !== 'original' ? styles.otherImgStyle : ''
              }`}
              style={{
                borderRadius: shape === 'circle' ? '50%' : '',
                width: size
              }}
            />
          ) : (
            <ImageIcon
              className={styles.imageIcon}
              style={{
                height: size,
                width: 'auto'
              }}
            />
          )}
        </Grid>
        <Grid className={styles.textContainer} style={paragraphStyle}>
          {mode === 'edit' ? (
            <InlineQuillEdit
              placeholder={'Click to add text'}
              value={content.text || ''}
              componentKey={props.component.componentkey}
              styleType={'p'}
              onChange={handleTextChange}
            />
          ) : (
            <span
              className={`ql-editor`}
              dangerouslySetInnerHTML={{
                __html: LessonComponentService.getUrlWithSas(content?.text)
              }}
            ></span>
          )}
        </Grid>
      </Grid>
      {mode === 'edit' && (
        <Grid>
          <ChangeFile
            component={props.component}
            assetkey={settings.assetkey}
            assetTypes={['image']}
            style={{ position: 'unset' }}
          />
        </Grid>
      )}
    </Grid>
  );
};
